import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑团队精心策划，带你深入影视世界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-500/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="px-2 py-1 rounded-full bg-accent-500 text-[10px] font-bold text-background-50 whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-300 mt-1.5 line-clamp-2">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}